import React from 'react'
import { Box, Grid, Typography, Card, CardContent, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import yeastarproduct from './yeastarproduct';
const RelatedProductYeastar = ({ currentItem }) => {
  if (
    !currentItem?.related ||
    !Array.isArray(currentItem.related)
  ) {
    return null;
  }

  // Use imported data
  const allProducts = Object.values(yeastarproduct).flat();
  const relatedProducts = allProducts.filter((product) =>
    currentItem.related.includes(Number(product.id))
  );

  if (!relatedProducts.length) return null;

  return (
    <Box sx={{ backgroundColor: '#E3F0FF',  px: { xs: 2, sm: 4 }, py: 6 }}>
       <Stack  direction="row"
  justifyContent="center"
  alignItems="center"
  sx={{ width: '100%', mt: 2, mb: 2 }}>
  <Typography
    variant="h2"
    sx={{
      color: 'black',
      backgroundColor: 'white',
      textAlign:'center',
      width:230,
      marginTop:1,
      marginBottom:2,
      borderRadius:'40px',
      fontSize:'20px',
      padding:2,
    }}
  >
    Related Products
  </Typography>
  </Stack>

      <Grid container spacing={4} justifyContent="center">
        {relatedProducts.map((item) => (
          <Grid
            item
            key={item.id}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Link
              to={`/Yealink-Product/${encodeURIComponent(item.name)}`}
              state={item}
              style={{ textDecoration: 'none' }}
            >
              <Card
                sx={{
                  borderRadius: '0px',
                  textAlign: 'center',
                  width: '230px',
                  minWidth: '230px',
                  maxWidth: '230px',
                  height: '360px',
                  backgroundColor: 'transparent',
                  cursor: 'pointer',
                  border: 'none',
                  boxShadow: 'none',
                  transition: 'transform 0.3s',
                  '&:hover img': {
                    transform: 'scale(1.1)',
                  },
                }}
              >
                <Box
                  sx={{
                    
                    height: '190px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                  }}
                >
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{
                      width: item.isize,
                      height: item.isize,
                      transition: 'transform 0.5s ease',
                    }}
                  />
                </Box>

                <CardContent
                  sx={{
                    paddingLeft: '10px' ,
                    paddingRight:'10px',
                    height: '170px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 'semibold',
                      fontSize: item.namesizef,
                      marginBottom: '6px',
                      color: '#000000',
                      textAlign: 'center',
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: '12px',
                      color: 'secondary.contrastText',
                      textAlign: 'center',
                    }}
                  >
                    {item.details}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RelatedProductYeastar
